"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LIST : SELECTABLE : STYLES --------------- ++++++++++ */


var _default = {
  selectablelist: {
    '& .list-item': {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      lineHeight: (0, _index.pxToEm)(24),
      margin: (0, _index.pxToEm)(5),
      '& .option-text': {
        opacity: 0.5,
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: _index.theme.typography.weight.medium,
        marginLeft: (0, _index.pxToEm)(3)
      }
    }
  }
};
exports.default = _default;